export default __webpack_public_path__ + "static/2_27-042e41af50cf1ad752b0a628bb9a1669.png";